import TableCell, { TableCellProps } from '@mui/material/TableCell'
import React, { FC } from 'react'

type CustomTableCellProps = TableCellProps & {
  maxWidth?: string
  wordBreak?: 'break-word' | 'normal'
  children: React.ReactNode
  dataTest?: string
}

export const CustomTableCell: FC<CustomTableCellProps> = ({ sx = {}, maxWidth = '250px', dataTest, wordBreak, children, ...props }) => (
  <TableCell
    data-testid={dataTest}
    sx={{
      wordBreak: wordBreak || 'break-word',
      maxWidth: maxWidth || '150px',
      fontSize: '16px',
      ...sx,
    }}
    {...props}
  >
    {children}
  </TableCell>
)
